




































































































































import ReviewList from '@/components/ReviewList'
import DropDown from '@/components/DropDown.vue'
import DropDownSearch from '@/components/DropDownSearch.vue'
import StatsTeam from '@/components/StatsTeam.vue'
import PourcentageStatTag from '@/components/PourcentageStatTag.vue'
import utils from '@/utils.coffee'
import gql from '@/gqlService.coffee'
import queries from "@/gql/queries.coffee"

header_height = 170

export default {
    "name": "ReviewListFilterFlow",
    "components": {
        ReviewList,
        DropDown,
        DropDownSearch,
        PourcentageStatTag,
        StatsTeam
    }
    "props": {}
    "computed":
        "style": ()->
            return {
                height: this.height
            }
        "pourcentageStatTagValue": ()->
            ret = 0
            self = @
            if @$store.state.stats
                sum = @$store.state.stats.reduce((acc, current)->
                    if current.consultant_id == self.$store.state.profile.data.uid
                        acc.total += current['from_this_morning_count']
                        acc.total -= current['from_this_morning_impossible']
                        acc.validated += current['from_this_morning_validated_count']
                    return acc
                ,{total:0, validated:0})
                if sum.total != 0
                    ret = Math.round(100 * sum.validated / sum.total)
            return ret
    "data": ()->
        self = this
        return {
            "showPad": false,
            "tag_set": [
                    {name: 'Supprimé', code: 'deleted'},
                    {name: 'Répondu', code: 'answered'},
                    {name: 'Impossible', code: 'Impossible'}
            ]
            "height": (window.innerHeight-30)+ "px"
            "listHeight": (window.innerHeight-header_height)+ "px"
            "filters":
                # "positive": false
                "tag": {name: null, code: null}
                "dateBegin": null,
                "dateEnd": null
                "search_string": ""
                "classified": false
                "establishment": {"name": null, "uid": null}
                "sentiment": {"name": null, "value": null}
                "platform": {"name": null, "uid": null}
                "status": {"name": null, "uid": null}
            "establishments": null
            "establishment": {"name": null}
            "sentiments": [{"name": "Positif", "value": true}, {"name": "Négatif", "value": false}]
            "sentiment": {"name": null, "value": null}
            "platforms": null
            "platform": {"name": null}
            "status_set": null
            "status": {"name": null}
            "dateBegin": null
            "dateEnd": null
            "tag": {name: null, code: null}
        }
    "methods":
        "dateEndClicked": (item)->
            if @dateEnd == ""
                @filters.dateEnd = null
            else
                @filters.dateEnd = @dateEnd
        "dateBeginClicked": (item)->
            if @dateBegin == ""
                @filters.dateBegin = null
            else
                @filters.dateBegin = @dateBegin
        "statusClicked": (item)->
            @status = item or {"name": null, "value": null}
            @filters.classified = (@status.value == "Classified")
                
            @filters.status = @status
        "tagClicked": (item)->
            @tag = item or {name: null, code: null}
            @filters.tag = @tag
        "sentimentClicked": (item)->
            @sentiment = item or {"name": null, "value": null}
            @filters.sentiment = @sentiment
        "establishmentClicked": (item)->
            @establishment = item or {"name": null, "uid": null}
            @filters.establishment = @establishment
        "platformClicked": (item)->
            @platform = item or {"name": null, "uid": null}
            @filters.platform = @platform
        "setHeight": utils.debounce(
            ()->
                @height = (window.innerHeight-30)+ "px"
                @listHeight = (window.innerHeight-header_height)+ "px" 
                return
            , 500)
        "previousEstablishment": ()-> 
            currentIndex = @establishments.indexOf(@establishment)
            if currentIndex > 0 
                @establishment = @establishments[currentIndex - 1]
            else 
                @establishment = @establishments[@establishments.length - 1]
        "nextEstablishment": ()->
            currentIndex = @establishments.indexOf(@establishment)
            if currentIndex < @establishments.length - 1
                @establishment = @establishments[currentIndex + 1]
            else
                @establishment = @establishments[0]
        "clickPadButton": ()->
            @showPad = !@showPad;
            @$emit("toggle-pad", @showPad)

    "mounted": ()->
        self = this
        this.setHeight()
        window.addEventListener('resize', this.setHeight)
        @establishments = await gql.query({
            "model": 'establishment_set'
            "filters": 'consultant__uid:"'+String(self.$store.state.profile.data.uid)+'"'
            "fields": "uid name"
        })
        
        @platforms = await gql.query({
            "model": 'platform_set'
            "fields": "uid name"
        })
        
        data = await queries.run("named_state_set")
        @status_set = data.body.data.named_state_set

        @$djangows['onmodelsignals']({"modelName": "review", "appLabel": "review"}, (event)->
            response = await queries.run('get_consultants_stats_from_view', [])
            self.$store.commit(
                'set_stats',
                response.body.data.get_consultants_stats_from_view)

        )
    "watch":
        "$store.state.selected_review_uid": ()->
            return
                
}
